// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_31-6";
export var headerCell = "_31-2";
export var rowWrapper = "_31-4";
export var stickyAggregationCell = "_31-a";
export var stickyAggregationRow = "_31-7";
export var stickyColumnCell = "_31-9";
export var stickyColumnHeaderCell = "_31-8";
export var table = "_31-1";
export var virtualRowWrapper = "_31-5";
export var virtualTableContainer = "_31-0";
export var white = "_31-3";